import { render, staticRenderFns } from "./MidwifeMainFile.vue?vue&type=template&id=0badbfc2"
import script from "./MidwifeMainFile.vue?vue&type=script&lang=js"
export * from "./MidwifeMainFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports